import { Stack, Box } from '@mui/material';
import { useState } from 'react';
import Modal from '../../Tools/Modal'
import { LoadingButton } from '@mui/lab';
import DownloadIcon from '@mui/icons-material/DownloadForOffline';
import API from '../../../services/API.js';

export default function Docs({enrollment, open, onClose}){

    const [downloading, setDownloading] = useState(false)

    const download = doc => {

        API.download(`/study/enrollments/${enrollment.id}/${doc.id}/doc.pdf`)
            .finally(() => setDownloading(false))

        return setDownloading(doc.id)
    }

    return enrollment &&

        <Modal open={open} title='Documents' onClose={onClose} noActions>

            {enrollment?.docs.map(d => 
                <Stack 
                    key={d.id}
                    direction='row'
                    justifyContent='space-between'
                    alignItems='center'
                    width={320}
                    sx={{pt: 1, pb: 1, borderBottom: 'solid 1px lightgrey'}}
                >
                    <Box>{d.title}</Box>

                    <LoadingButton 
                        onClick={() => download(d)} 
                        loading={downloading === d.id}
                    >
                        <DownloadIcon />
                    </LoadingButton>

                </Stack>
            )}

        </Modal>
}
